import { render, staticRenderFns } from "./WidgetContainer.vue?vue&type=template&id=0db7a368"
import script from "./WidgetContainer.vue?vue&type=script&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports